import {AdmissionFromSearch} from "../../../../../services/AdmissionsService";
import {PACKET_SIZE_LIMIT_IN_MB} from "../../../../../utils/constants";

export const shouldShowPacketSizeLimitAlert = (
  admission: AdmissionFromSearch,
  isResideAdmin: boolean,
  hasShowLargeAdmissionWarningFlag?: boolean,
): boolean => {
  const packetSizeExceeded =
    (admission.resources?.finalPdf?.packetSize ?? 0) > PACKET_SIZE_LIMIT_IN_MB;

  if (isResideAdmin) {
    // Reside admins are not affected by feature flag so show the alert when the packet size exceeds the limit
    return Boolean(packetSizeExceeded);
  }

  return Boolean(hasShowLargeAdmissionWarningFlag && packetSizeExceeded);
};
